<template>
  <div class="show-nav" style="padding-top: 100px">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$parent.goNav('/app')" class="header-download"></a>
      </div>
      <div class="header-center">
        <a @click="$parent.goNav('/')" class="header-logo"> <img  :src="$store.state.appInfo.site_logo || '/static/image/d11_logo_h5.png'" onerror="this.src = '/static/image/d11_logo_h5.png'" width="100%" />  </a>
        <h4 class="header-title hide"></h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
        <a v-if="!$store.state.token" @click="$parent.goNav('/login')" class="header-action" id="login_btn" style="font-size: 12px">登录</a>
      </div>
    </div>
    <div class="mod-promotions">
      <div class="menu-sub-fixed">
        <ul id="atypes" class="menu-sub clearfix">
          <li :class="actType == '' ? 'current' : '  '" @click="changActType('')"><a id="alloffers_btn" href="javascript:void(0);">全部优惠</a></li>
          <li :class="actType == item.id ? 'current' : '  '" v-for="(item, index) in activitytypeList" :key="index" @click="changActType(item.id)">
            <a href="javascript:void(0);"> {{ item.name }} </a>
          </li>
        </ul>
      </div>

      <!-- <ul class="promo-hot">
        <li ><img src="https://cn.mebetx20.com:9119/fimg/i202206f27bf7b6ebda402fa07e45e87e3c9dfd.jpg" /></li>
        <li ><img src="https://cn.mebetx20.com:9119/fimg/i202206a2f231a229c545d695ecbe2569afd699.jpg" /></li>
        <li ><img src="https://cn.mebetx20.com:9119/fimg/i202205f23b8ed8bdb7445f892cabdf52d86c2d.jpg" /></li>
      </ul> -->

      <ul class="promo-list">
        <li class="clearfix" style="display: flex" v-for="(item, index) in activitylistList" v-if="item.state == 1"  :key="index" @click="$parent.goNav(`/activityInfo?id=${item.id}`)">
          <div class="promotions-banner-wrap"><img :src="item.banner" class="promotions-banner" /></div>
          <div class="promotions-info clearfix">
            <div class="actinfo">
              <h3>{{ item.title }}</h3>
              <p></p>
            </div>
            <div class="actdetail">
              <!-- <span><em>0</em> 玩家参与中</span><span><i></i>1735</span> -->
              <span
                ><em> {{ item.created_at }}</em>
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activity',
  data() {
    return {
      activitytypeList: [],
      actType: '',
      activitylistList: [],
    };
  },
  created() {
    let that = this;
    that.activitytype();
    that.activitylist();
  },
  methods: {
    activitytype() {
      let that = this;
      that.$apiFun.post('/api/activitytype', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitytypeList = res.data;
        }
      });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
    changActType(val) {
      let that = this;
      if (val == that.actType) {
        return;
      }
      that.actType = val;
      that.activitylist();
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/dashboard-activity.b2be1233.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/activity.vue